(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resell-wholesale-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const tier = event.target.closest('[data-tier-qty]');
  if (!tier) return;
  const productArea = tier.closest('product-info, .product-info, [data-product-id], main') || document;
  const quantity = productArea.querySelector('input[name="quantity"]');
  if (quantity) {
    quantity.value = tier.dataset.tierQty;
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
    quantity.focus();
  }
});
  } catch(e) { console.error(e); }
})();

})();
